<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="computedDialog"
        :cons="{ title: $t('section.edit_part') }"
        hide-overlay
        max-width="800"
        reloadable
      >
        <v-card v-if="computedDialog" outlined>
          <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.icon && tab.text"
                :element-name="`${serviceName}-${componentName}-${tab.icon}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="tab.text"
              />
            </template>
            <template v-slot:staticItems>
              <v-tab-item class="mt-2">
                <v-row class="mt-1 mb-3" no-gutters>
                  <v-col class="pa-2" cols="12" md="6">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="valueComputed.title"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        class="contentinfo"
                        :label="$t('section.title')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-valueComputed-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('section.title')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12" md="6">
                    <div class="rowinfo">
                      <v-select
                        v-model="valueComputed.text_position"
                        :items="translatedTextPosition"
                        dense
                        hide-details
                        :label="$t('section.position_text')"
                        outlined
                        class="contentinfo"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-valueComputed-text_position`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('section.position_text')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12" md="10">
                    <pic-selector
                      :edit-name="false"
                      :field.sync="valueComputed.object.url"
                      one-pic
                      single
                    />
                  </v-col>

                  <v-col class="pa-2 d-flex align-center" cols="12" md="2">
                    <div class="rowinfo">
                      <v-btn
                        color="orange lighten-3"
                        class="contentinfo"
                        small
                        @click="manualDialog = true"
                      >
                        <v-icon>mdi-multimedia</v-icon>
                        {{ $t("section.add_video") }}
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-valueComputed-multimedia`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('section.add_video')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12">
                    <div class="rowinfo">
                      <v-textarea
                        v-model="valueComputed.text"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        class="contentinfo"
                        dense
                        :label="$t('section.text')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-valueComputed-text`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('section.text')"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item class="mt-2">
                <call-to-action v-model="valueComputed.button" />
              </v-tab-item>
            </template>
          </custom-tabs>

          <custom-popup
            v-model="manualDialog"
            :cons="{ title: $t('section.add_video') }"
            max-width="500"
          >
            <v-card class="p-8">
              <div class="rowinfo">
                <v-text-field
                  v-model="video"
                  class="my-2"
                  dense
                  hide-details
                  :label="$t('section.address_video')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-valueComputed-video`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('section.address_video')"
                />
              </div>
            </v-card>
          </custom-popup>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import CallToAction from "@/view/components/CallToAction";
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";
import PicSelector from "@/view/components/UploadCenter/picSelector";

export default {
  name: "serviceSectionCard",

  components: { PicSelector, PicSelectorSingle, CallToAction },

  props: {
    value: Object,
    dialog: Boolean,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "service-section-card",
      tabs: 0,
      manualDialog: false,

      image: "",
      video: null,
    };
  },

  computed: {
    tabItems() {
      return [
        {
          text: this.$t("section.tab_content"),
          icon: "content-save-edit-outline",
        },
        { text: this.$t("section.tab_edit_button"), icon: "pencil-outline" },
      ];
    },
    textPosition() {
      return [
        { text: this.$t("section.position_left"), value: "left" },
        { text: this.$t("section.position_right"), value: "right" },
      ];
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("update:dialog", val);
      },
    },
    translatedTextPosition() {
      return [
        { text: this.$t("section.position_left"), value: "left" },
        { text: this.$t("section.position_right"), value: "right" },
      ];
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    dialog() {
      this.$forceUpdate();
    },
    image: {
      deep: true,
      handler(value) {
        this.valueComputed.object = {
          type: "image",
          url: value,
        };
      },
    },
    video(value) {
      let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");
      const videoLink = reg.exec(value)?.[1] ?? value;

      this.valueComputed.object = {
        type: "video",
        url: videoLink,
      };
    },
  },
};
</script>

<style scoped>
[dir="rtl"] .contentinfo,
[dir="rtl"] .rowinfo {
  text-align: right;
}
[dir="ltr"] .contentinfo,
[dir="ltr"] .rowinfo {
  text-align: left;
}
</style>
